import classnames from 'classnames';
import renderSVG from '@Controls/render-icon';
/* eslint-disable jsx-a11y/anchor-is-valid */
const HowToChildCta = (props) => {
	const { attributes, setAttributes = 'not_set' } = props;

	let target = '_self';
	const rel = 'noopener noreferrer';
	if (attributes.ctaTarget) {
		target = '_blank';
	}

	let ctaIconoutput = '';
	if (attributes.ctaIcon !== '') {
		ctaIconoutput = (
			<span
				className={classnames(
					`wpsp-ifb-${attributes.ctaType}-icon`,
					`wpsp-ifb-align-icon-${attributes.ctaIconPosition}`
				)}
			>
				{renderSVG(attributes.ctaIcon)}
			</span>
		);
	}

	if (setAttributes !== 'not_set') {
		return (
			<div className="wpsp-ifb-cta wpsp-howto-child-cta-link-style">
				{attributes.ctaType === 'text' && (
					<a
						target={target}
						className="wpsp-howto-child-cta-link"
						rel={rel}
					>
						{attributes.ctaIconPosition === 'before' &&
							ctaIconoutput}
						<span className="wpsp-inline-editing">
							{attributes.ctaText}
						</span>
						{attributes.ctaIconPosition === 'after' &&
							ctaIconoutput}
					</a>
				)}
			</div>
		);
	}
	return (
		<div className="wpsp-ifb-cta wpsp-howto-child-cta-link-style">
			{attributes.ctaType === 'text' && (
				<a
					href={attributes.ctaLink}
					target={target}
					className="wpsp-howto-child-cta-link"
					rel={rel}
				>
					{attributes.ctaIconPosition === 'before' && ctaIconoutput}
					<span className="wpsp-inline-editing">
						{attributes.ctaText}
					</span>
					{attributes.ctaIconPosition === 'after' && ctaIconoutput}
				</a>
			)}
		</div>
	);
};

export default HowToChildCta;
